import { DIET_FLUC_TYPE, type DietFluc } from '../../types/patient';

/** An order the EHR processor wrote (EMR / EMR Adjustment type, an EHR order number, or EHR text). */
export function isEhrSourced(row: DietFluc | null | undefined): boolean {
  if (!row) return false;
  return row.type === DIET_FLUC_TYPE.EMR
    || row.type === DIET_FLUC_TYPE.EMRAdjustment
    || !!(row.eHR_OrderID ?? '').trim()
    || !!(row.ehrDietText ?? '').trim();
}

/**
 * WinForms repLuType: 1 Manual, 2 EMR, 3 EMR Adjustment; anything else
 * blank. "EMR" reads as the facility's EHR title.
 */
export function dietFlucTypeName(type: number | null | undefined, ehrTitle: string): string {
  if (type === DIET_FLUC_TYPE.Manual) return 'Manual';
  if (type === DIET_FLUC_TYPE.EMR) return ehrTitle;
  if (type === DIET_FLUC_TYPE.EMRAdjustment) return `${ehrTitle} Adjustment`;
  return '';
}

/**
 * The resident's current diet order: the row with the latest
 * Change_Date at or before now (PKey breaks ties), the same rule the
 * server and the EHR processor use.
 */
export function currentDietFluc(history: DietFluc[], nowMs: number = Date.now()): DietFluc | null {
  let best: DietFluc | null = null;
  let bestTime = -Infinity;
  for (const row of history) {
    const t = new Date(row.change_Date ?? 0).getTime();
    if (Number.isNaN(t) || t > nowMs) continue;
    if (best == null || t > bestTime || (t === bestTime && row.pKey_Diet_Flucs > best.pKey_Diet_Flucs)) {
      best = row;
      bestTime = t;
    }
  }
  return best;
}

/** "There is 1 held X diet order" / "There are N held X diet orders". */
export function heldOrdersPhrase(count: number, ehrTitle: string): string {
  return count === 1
    ? `There is 1 held ${ehrTitle} diet order`
    : `There are ${count} held ${ehrTitle} diet orders`;
}

/** Title of the Dashboard card for held EHR diet orders: "Held PCC diet changes". */
export function heldChangesTitle(ehrTitle: string): string {
  return `Held ${ehrTitle} diet changes`;
}

/** "1 held PCC diet change waiting for review" / "3 held PCC diet changes waiting for review". */
export function heldChangesWaitingText(count: number, ehrTitle: string): string {
  return `${count} held ${ehrTitle} diet change${count === 1 ? '' : 's'} waiting for review`;
}
